<svg class="pl_icon" role="img">
  <use xlink:href="/assets-static/icons/pl_icon_arrow-graph.svg#pl_icon_arrow-graph"></use>
</svg>

<style lang="scss">
  svg {
    flex: 0 0 24px;
    height: 24px;
    margin-right: 16px;
  }
</style>
